import { Stack } from 'expo-router'
import { env } from '@/lib/env'
import { ServicesComingSoon } from '@/components/services/ServicesComingSoon'

/** Services owns a short request funnel; its screens share the tab shell. */
export default function ServicesLayout() {
  // WIP gate: con `EXPO_PUBLIC_SERVICES_ENABLED=false` el tab es visible y esta
  // ventana es su contenido (el funnel no está publicado). Cubre el root del
  // tab y cualquier deep link; con el flag encendido se monta el Stack real.
  if (!env.isServicesEnabled) return <ServicesComingSoon />
  return <Stack screenOptions={{ headerShown: false }} />
}
